export default __webpack_public_path__ + "static/media/2829 spice rack side.0ffdbeb4.png";